/* ---- utilitário: remove acentos -------------------------- */
function removeAccents(str){
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase();
}

/* ---- Storefront API ------------------------------------- */
const STOREFRONT_TOKEN = "fa97136c54080ed5172dbc90cd512abf";
const GRAPHQL_URL      = "/api/2024-04/graphql.json";

/* carrega TODAS as coleções (250 por página) */
async function fetchAllCollections(){
  let list=[], endCursor=null, hasNextPage=true;
  while(hasNextPage){
    const query=`{
      collections(first:250${endCursor?`, after:"${endCursor}"`:""}){
        edges    { cursor node{ title handle } }
        pageInfo { hasNextPage endCursor }
      }
    }`;
    const r = await fetch(GRAPHQL_URL,{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
        "X-Shopify-Storefront-Access-Token":STOREFRONT_TOKEN
      },
      body:JSON.stringify({query})
    }).then(r=>r.json());

    r.data.collections.edges.forEach(e=>list.push(e.node));
    hasNextPage = r.data.collections.pageInfo.hasNextPage;
    endCursor   = r.data.collections.pageInfo.endCursor;
  }
  return list;           // [{title,handle}, …]
}

/* cria faixa 0-9 / A-Z / Todos */
function createAlphaNav(){
  const nav   = document.getElementById("alphaNav");
  const chars = ["num",..."ABCDEFGHIJKLMNOPQRSTUVWXYZ","all"];
  chars.forEach(ch=>{
    const span=document.createElement("span");
    span.dataset.letter=ch;
    span.textContent   = ch==="num"?"0-9":ch==="all"?"Todos":ch;
    nav.appendChild(span);
  });
}

/* monta HTML da lista + botão X */
function showMatchList(matches){
  const items = matches.map(m=>
    `<li class="list-group-item">
       <a href="/collections/${m.handle}">${m.title}</a>
     </li>`).join("");

  $("#matchWrap").remove();          // remove lista anterior
  $("#searchForm").after(`
    <div id="matchWrap" class="match-wrap">
      <button type="button" class="match-close" title="Fechar"></button>
      <ul id="matchList" class="list-group mt-2">${items}</ul>
    </div>
  `);
}

/* scroll suave até o topo */
function scrollTopSmooth(){
  if("scrollBehavior" in document.documentElement.style){
    window.scrollTo({top:0,behavior:"smooth"});
  }else{
    $("html,body").animate({scrollTop:0},600);
  }
}

/* -------------------- INIT -------------------- */
document.addEventListener("DOMContentLoaded",async()=>{

  createAlphaNav();                           // 1) faixa A-Z
  const collections = await fetchAllCollections();   // 2) dados

  /* 3) autocomplete clássico */
  $("#collectionSearch").autocomplete({
    source: collections.map(c=>c.title)
  });

  /* ---------- BUSCA livre ---------- */
  function runSearch(){
    const term = removeAccents($("#collectionSearch").val().trim());
    if(!term) return;

    const matches = collections.filter(c =>
      removeAccents(c.title).includes(term)
    );

    if(matches.length===0){
      alert("Nenhuma coleção encontrada!");
    }else if(matches.length===1){
      window.location.href = `/collections/${matches[0].handle}`;
    }else{
      showMatchList(matches);
    }
  }

  /* botão Buscar (animação) */
  $("#searchButton").on("click",()=>{
    const btn=$("#searchButton");
    btn.addClass("run-effect");
    setTimeout(()=>{btn.removeClass("run-effect");runSearch();},1350);
  });

  /* ENTER → simula o clique */
  $("#collectionSearch").on("keydown",e=>{
    if(e.key==="Enter"){e.preventDefault();$("#searchButton").trigger("click");}
  });

  /* ---------- Faixa A-Z — click + touchstart ---------- */
  $("#alphaNav").on("touchstart click","span",function(e){
    e.preventDefault();          // evita duplo-tap e atraso
    if(e.type==="touchstart"){           // trata só uma vez
      $(this).data("touched",true);
      alphaSelect($(this));      // nossa função
      return;
    }
    if($(this).data("touched")){ // já tratou no touchstart
      $(this).removeData("touched");
      return;
    }
    alphaSelect($(this));
  });

  function alphaSelect($span){
    const letter=$span.data("letter");
    $("#alphaNav span").removeClass("active");
    $span.addClass("active");

    let filtered;
    if(letter==="all")        filtered=collections;
    else if(letter==="num")   filtered=collections.filter(c=>/^\d/.test(c.title));
    else                      filtered=collections.filter(c=>removeAccents(c.title)
                                  .startsWith(letter.toLowerCase()));

    if(filtered.length===0){
      alert("Nenhuma coleção encontrada!");
    }else if(filtered.length===1){
      window.location.href=`/collections/${filtered[0].handle}`;
    }else{
      showMatchList(filtered);
    }
  }

  /* ---------- botão × fecha + sobe ---------- */
  $(document).on("click",".match-close",()=>{
    $("#matchWrap").remove();
    scrollTopSmooth();
  });

});


(() => {
  const PULSE_TIME         = 4000;                     // ms
  const STORAGE_KEY_TERM   = 'collectionSearchTerm';
  const STORAGE_KEY_HINT   = 'pulseHintSeen';          // mostra só 1x
  const COLLECTION_LANDING = '/collections';
  const HINT_TEXT          = 'Toque novamente para ir à coleção';
  const HINT_LIFETIME      = 2600;                     // ms
  const SELECTOR           = '.tabs-categorys li a';

  const timeouts = new Map();

  function showOnceHintNear(el, text = HINT_TEXT, lifetime = HINT_LIFETIME){
    if (sessionStorage.getItem(STORAGE_KEY_HINT) === '1') return;
        sessionStorage.setItem(STORAGE_KEY_HINT, '1');

    const r = el.getBoundingClientRect();
    const bubble = document.createElement('div');
    bubble.textContent = text;
    bubble.setAttribute('role','status');

    Object.assign(bubble.style, {
      position:'fixed',
      left: (r.left + r.width/2) + 'px',
      top: (r.top - 10) + 'px',
      transform:'translate(-50%,-100%)',
      background:'rgba(0,0,0,.9)',
      color:'#fff',
      padding:'8px 10px',
      borderRadius:'8px',
      fontSize:'12px',
      lineHeight:'1.2',
      whiteSpace:'nowrap',
      boxShadow:'0 6px 18px rgba(0,0,0,.25)',
      zIndex:'9999',
      pointerEvents:'none',
      opacity:'0',
      transition:'opacity .2s, transform .2s'
    });

    document.body.appendChild(bubble);
    requestAnimationFrame(() => {
      bubble.style.opacity = '1';
      bubble.style.transform = 'translate(-50%,-110%)';
    });
    setTimeout(() => {
      bubble.style.opacity = '0';
      bubble.style.transform = 'translate(-50%,-90%)';
    }, Math.max(0, lifetime - 200));
    setTimeout(() => bubble.remove(), lifetime);
  }

  document.addEventListener('click', (evt) => {
    const link = evt.target.closest(SELECTOR);
    if (!link) return;

    const isPulsing = link.classList.contains('pulsando');

    /* SEGUNDO CLIQUE → ir para /collections */
    if (isPulsing) {
      evt.preventDefault(); // evita qualquer navegação do <a>
      const term = link.textContent.trim();
      localStorage.setItem(STORAGE_KEY_TERM, term);
      window.location.href = COLLECTION_LANDING;
      return;
    }

    /* PRIMEIRO CLIQUE → impede navegação, ativa pulso e mostra hint */
    evt.preventDefault(); // <- garante que não saia da página no 1º clique

    // limpa outros botões pulsando
    document.querySelectorAll(SELECTOR + '.pulsando').forEach(el => {
      el.classList.remove('pulsando');
      clearTimeout(timeouts.get(el));
      timeouts.delete(el);
    });

    // ativa pulso no clicado
    link.classList.add('pulsando');
    showOnceHintNear(link);

    const to = setTimeout(() => {
      link.classList.remove('pulsando');
      timeouts.delete(link);
    }, PULSE_TIME);
    timeouts.set(link, to);
  });
})();

(() => {
  const KEY = 'collectionSearchTerm';

  // tenta vários seletores comuns de busca
  const INPUT_SEL  = '#collectionSearch, input[type="search"][name="q"], input[type="search"], input#Search-In-Template';
  const BUTTON_SEL = '#searchButton, button[type="submit"][name="search"], form[role="search"] button[type="submit"]';

  function waitForEl(selector, timeout = 8000){
    return new Promise((resolve, reject) => {
      const found = document.querySelector(selector);
      if (found) return resolve(found);

      const obs = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) { obs.disconnect(); resolve(el); }
      });
      obs.observe(document.documentElement, { childList:true, subtree:true });
      setTimeout(() => { obs.disconnect(); reject(new Error('timeout')); }, timeout);
    });
  }

  function fireInputEvents(input){
    ['input','change'].forEach(t =>
      input.dispatchEvent(new Event(t, { bubbles:true }))
    );
  }
  function pressEnter(el){
    ['keydown','keypress','keyup'].forEach(t =>
      el.dispatchEvent(new KeyboardEvent(t, {
        key:'Enter', code:'Enter', keyCode:13, which:13, bubbles:true
      }))
    );
  }

  document.addEventListener('DOMContentLoaded', async () => {
    const term = localStorage.getItem(KEY);
    if (!term) return;

    try {
      // espera o input existir (tema pode hidratar depois)
      const input = await waitForEl(INPUT_SEL, 8000);
      input.focus();
      input.value = term;
      fireInputEvents(input);

      // tenta botão; se não tiver, manda Enter no input
      const btn = document.querySelector(BUTTON_SEL);
      if (btn) {
        ['mousedown','mouseup','click'].forEach(evt =>
          btn.dispatchEvent(new MouseEvent(evt, { bubbles:true, cancelable:true }))
        );
      } else {
        pressEnter(input);
      }
    } catch (e) {
      // último recurso: adiciona ?q=term na URL
      try {
        const u = new URL(location.href);
        u.searchParams.set('q', term);
        location.replace(u.toString());
      } catch(_) {}
    } finally {
      localStorage.removeItem(KEY);
    }
  });
})();


